module.exports = __webpack_public_path__ + "img/30.82bf0b05.png";